<template>
  <div class="m-card" style="gap:10px">
    <div style="display: flex; align-items: center;gap:7px">
      <div
        :style="{ background: color }"
        style="border-radius: 50px; padding: 4px; display: flex"
      >
        <span class="material-icons-outlined">
          {{ icon }}
        </span>
      </div>
      <div>{{ title }}</div>
    </div>
    <div style="font-size:2em;font-weight:300;">{{ value }}</div>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    value: {
      type: Number,
      default: 0,
    },
    color: {
      type: String,
      default: "",
    },
  },
};
</script>

<style>
</style>